import React from 'react';

import { FormControl, Tooltip, Text } from 'native-base';
// import { Tooltip } from "~/native-ui/Tooltip";

export { FormControl };

const Label = FormControl.Label;
const RenderWithoutTooltip = ({ children }) => {
    return <React.Fragment>{children}</React.Fragment>;
};

FormControl.Label = ({ label, tooltip, ...props }) => {
    const TooltipComponent = tooltip ? Tooltip : RenderWithoutTooltip;
    return (
        <Text>
            <TooltipComponent label={tooltip} hasArrow placement="top">
                <Label
                    {...props}
                    display="inline"
                    _text={{ ...props.text, whiteSpace: 'pre-wrap' }}
                    width="max-content"
                    maxWidth="100%"
                >
                    {props.children || label || null}
                </Label>
            </TooltipComponent>
        </Text>
    );
};
